"use client";
import { useEffect } from "react";

/**
 * FullScreenLoader
 * ÚNICO prop:
 * - open: boolean (muestra/oculta el overlay)
 */
export default function FullScreenLoader({ open = false }) {
  // Bloquear scroll mientras esté abierto
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev || "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fs-loader" aria-live="polite" aria-busy="true" role="status">
      <div className="spinner" aria-hidden="true" />
      <style jsx>{`
        .fs-loader {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.35);
          backdrop-filter: blur(2px);
          z-index: 10000;
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: all; /* bloquea clicks */
        }
        /* === Aro gris (ring) === */
        .spinner {
          width: 56px;            /* tamaño del círculo */
          height: 56px;
          border-radius: 50%;
          border: 4px solid #c7c7c7;  /* gris claro en todo el aro */
          border-top-color: #6b6b6b;  /* gris un poco más oscuro para marcar el giro */
          animation: spin 0.8s linear infinite;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        @media (prefers-reduced-motion: reduce) {
          .spinner { animation: none; }
        }
      `}</style>
    </div>
  );
}
